import React, { Component } from 'react';
import '../../../stylesheets/document.scss';
import BootstrapTable from 'react-bootstrap-table-next';
import { changePath } from '../../../utils/common';

export default class Web extends Component {
  state = {
    header: 'Rate Limit',
    data: [
      {
        key: '1',
        api_name: '/rest/auth/angelbroking/user/v1/loginByPassword',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '2',
        api_name: '/rest/auth/angelbroking/jwt/v1//generateTokens',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: '1000',
      },
      {
        key: '3',
        api_name: '/rest/secure/angelbroking/user/v1/getProfile',
        limit_rate_second: '3',
        limit_rate_minute: 'NA',
        limit_rate_hour: '1000',
      },
      {
        key: '4',
        api_name: '/rest/secure/angelbroking/user/v1/logout',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '5',
        api_name: '/rest/secure/angelbroking/user/v1/getRMS',
        limit_rate_second: '2',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '6',
        api_name: '/rest/secure/angelbroking/order/v1/placeOrder',
        limit_rate_second: '9',
        limit_rate_minute: '500',
        limit_rate_hour: '1000',
      },
      {
        key: '7',
        api_name: '/rest/secure/angelbroking/order/v1/modifyOrder',
        limit_rate_second: '9',
        limit_rate_minute: '500',
        limit_rate_hour: '1000',
      },
      {
        key: '8',
        api_name: '/rest/secure/angelbroking/order/v1/cancelOrder',
        limit_rate_second: '9',
        limit_rate_minute: '500',
        limit_rate_hour: '1000',
      },
      {
        key: '9',
        api_name: '/rest/secure/angelbroking/order/v1/getOrderBook',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '10',
        api_name: '/rest/secure/angelbroking/order/v1/getLtpData',
        limit_rate_second: '10',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '11',
        api_name: '/rest/secure/angelbroking/order/v1/getPosition',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '12',
        api_name: '/rest/secure/angelbroking/order/v1/getTradeBook',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '13',
        api_name: '/rest/secure/angelbroking/order/v1/convertPosition',
        limit_rate_second: '10',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '14',
        api_name: '/rest/secure/angelbroking/order/v1/searchScrip',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '15',
        api_name: '/rest/secure/angelbroking/order/v1//details/{GuiOrderID}',
        limit_rate_second: '10',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '16',
        api_name: '/rest/secure/angelbroking/portfolio/v1/getHolding',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '17',
        api_name: '/rest/secure/angelbroking/portfolio/v1/getAllHolding',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
      {
        key: '18',
        api_name: '/rest/secure/angelbroking/market/v1/quote',
        limit_rate_second: '10',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '19',
        api_name: '/rest/secure/angelbroking/margin/v1/batch',
        limit_rate_second: '10',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '20',
        api_name: '/rest/secure/angelbroking/gtt/v1/createRule',
        limit_rate_second: '9',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '21',
        api_name: '/rest/secure/angelbroking/gtt/v1/modifyRule',
        limit_rate_second: '9',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '22',
        api_name: '/rest/secure/angelbroking/gtt/v1/cancelRule',
        limit_rate_second: '9',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '23',
        api_name: '/rest/secure/angelbroking/gtt/v1/ruleDetails',
        limit_rate_second: '10',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '24',
        api_name: '/rest/secure/angelbroking/gtt/v1/ruleList',
        limit_rate_second: '10',
        limit_rate_minute: '500',
        limit_rate_hour: '5000',
      },
      {
        key: '25',
        api_name: '/rest/secure/angelbroking/historical/v1/getCandleData',
        limit_rate_second: '3',
        limit_rate_minute: '180',
        limit_rate_hour: '5000',
      },
      {
        key: '25',
        api_name: '/rest/secure/angelbroking/marketData/v1/optionGreek',
        limit_rate_second: '1',
        limit_rate_minute: 'NA',
        limit_rate_hour: 'NA',
      },
    ],
    columns: [
      {
        dataField: 'key',
        text: 'Sr. No',
      },
      {
        dataField: 'api_name',
        text: 'API Name',
      },
      {
        dataField: 'limit_rate_second',
        text: 'Throttling Limit Rate (Request/Second)',
      },
      {
        dataField: 'limit_rate_minute',
        text: 'Throttling Limit Rate (Request/Minute)',
      },
      {
        dataField: 'limit_rate_hour',
        text: 'Throttling Limit Rate (Request/Hour)',
      },
    ],
  };
  componentDidMount() {}
  render() {
    const { header, data, columns } = this.state;
    return (
      <div className='container-fluid font mb-5' id='/docs/RateLimit'>
        <div class='title doc-row'>
          <div class='doc-left'>
            <h1 id=''>{header}</h1>
            <p>
              Rate limiting defines limits on how many API calls can be made
              within a second.
            </p>
            <p>
              The limit-exceeding requests will fail and returns 403 Access
              denied because of exceeding rate limit.
            </p>
            <BootstrapTable
              hover
              keyField='id'
              data={data}
              columns={columns}
              wrapperClasses={'react-bootstrap-table1'}
              headerClasses='font'
            />
            <p className='' style={{ marginTop: '20px' }}>
              <strong style={{ fontWeight: '600' }}>NOTE: </strong>
              <ol>
                <li>
                  The Rate limit is calculated on the basis of client code.
                </li>
              </ol>
            </p>
            <br />

            <div class='row'>
              <div class='col-md-6'>
                <i
                  class=' changePrevious-Button fas fa-chevron-circle-left'
                  title='Previous'
                  onClick={() => changePath('/docs/Instruments')}
                ></i>

                {/* <input style={{ float: 'left' }} type="button" className="btn btn-primary btn-lg m-t-5" onClick={() => changePath('/docs/User')} value='<< Previous' /> */}
              </div>
              <div class='col-md-6'>
                <i
                  class=' changeNext-Button fas fa-chevron-circle-right'
                  title='Next'
                  onClick={() => changePath('/docs/ChangeLog')}
                ></i>

                {/* <input style={{ float: 'right' }} type="button" className="btn btn-primary btn-lg m-t-5" onClick={() => changePath('/docs/Orders')} value='Next >>' /> */}
              </div>
            </div>
          </div>
          {/* <div class="doc-right"></div> */}
        </div>
      </div>
    );
  }
}
